import React, { memo, forwardRef } from "react";
const SvgAlphabetC = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.39 18.66c.293-.2.553-.3.78-.3.307 0 .547.1.72.3.173.187.26.407.26.66 0 .173-.04.347-.12.52-.08.173-.253.353-.52.54-.347.24-.76.413-1.24.52a5.31 5.31 0 01-1.32.18c-.72 0-1.393-.113-2.02-.34a4.72 4.72 0 01-1.62-1 4.837 4.837 0 01-1.08-1.6c-.267-.627-.4-1.34-.4-2.14 0-.773.133-1.473.4-2.1.28-.627.653-1.16 1.12-1.6a4.983 4.983 0 011.62-1.02 5.543 5.543 0 012-.36c.467 0 .913.06 1.34.18.44.107.833.273 1.18.5.28.187.46.373.54.56.093.173.14.333.14.48 0 .267-.093.507-.28.72-.187.213-.44.32-.76.32-.107 0-.22-.02-.34-.06a1.889 1.889 0 01-.46-.26c-.16-.12-.353-.22-.58-.3a2.036 2.036 0 00-.78-.14c-.44 0-.827.093-1.16.28a2.512 2.512 0 00-.84.7 3.157 3.157 0 00-.48 1c-.107.36-.16.727-.16 1.1 0 .373.053.747.16 1.12.107.36.267.687.48.98.227.28.5.513.82.7.333.173.727.26 1.18.26.547 0 1.02-.133 1.42-.4z"
      />
    </svg>
  );
});
SvgAlphabetC.displayName = "SvgAlphabetC";
const MemoForwardRef = memo(SvgAlphabetC);
export default MemoForwardRef;
